import { CampaignPlaceEditorInitData } from '../actions/campaignPlaceEditor/initCampaignPlaceEditors';
import { getCampaignPlaceEditorId } from '../service/CampaignsEditHelpers/CampaignsEditHelpers';
import { EditCampaignData, EditCampaignValueField } from '../typings/campaignsEdit';
import { CampaignId } from '../typings/domain';

export function mapCampaignsDataForEditToInitPlaceData(
    campaigns: Record<CampaignId, EditCampaignData>
): CampaignPlaceEditorInitData[] {
    return Object.keys(campaigns).map(
        (campaignId: CampaignId): CampaignPlaceEditorInitData => {
            const value = campaigns[campaignId].value[EditCampaignValueField.place];

            return {
                editorId: getCampaignPlaceEditorId(campaignId),
                place: {
                    pageId: value.pageId,
                    placeId: value.placeId
                }
            };
        }
    );
}
